import React, { useEffect, useState } from 'react';
import './Services.scss';
import services from '../../utils/services';
import ServiceDetailsCard from '../../components/ServiceDetailsCard/ServiceDetailsCard';

function Services() {
    const [allServices, setAllServices] = useState([]);

    useEffect(() => {
        //scroll to top on page load
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setAllServices(services);
    }, []);

    return (
        <>
            <section className="page-hero services-hero top-padding-mobile">
                <div className="page-hero-container">
                    <div className="page-hero-content">
                        <div className="page-hero-badge">Our Expertise</div>
                        <h1 className="page-hero-title">Mechanical Systems Built for Public Spaces</h1>
                        <p className="page-hero-description">
                            We design, install, and maintain dependable mechanical systems for civic and institutional facilities across the GTA. From boiler and chiller plants to HVAC retrofits, plumbing, and controls, our crews keep schools, libraries, fire halls, and community hubs comfortable, efficient, and safe year-round. Every scope is engineered for longevity, code compliance, and ease of maintenance.
                        </p>
                        <div className="page-hero-stats">
                            <div className="hero-stat-item">
                                <div className="stat-number">4</div>
                                <div className="stat-label">Specialized Trades</div>
                            </div>
                            <div className="hero-stat-item">
                                <div className="stat-number">100%</div>
                                <div className="stat-label">Safety Compliance</div>
                            </div>
                            <div className="hero-stat-item">
                                <div className="stat-number">24/7</div>
                                <div className="stat-label">Service Support</div>
                            </div>
                        </div>
                    </div>
                    <div className="page-hero-visual">
                        <svg width="280" height="280" viewBox="0 0 280 280" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="140" cy="140" r="120" stroke="rgba(0, 175, 207, 0.15)" strokeWidth="2" fill="none"/>
                            <circle cx="140" cy="140" r="90" stroke="rgba(0, 175, 207, 0.2)" strokeWidth="2" fill="none"/>
                            <circle cx="140" cy="140" r="60" stroke="rgba(0, 175, 207, 0.25)" strokeWidth="2" fill="none"/>
                            <rect x="110" y="110" width="60" height="60" rx="8" fill="rgba(0, 175, 207, 0.08)" transform="rotate(45 140 140)"/>
                            <path d="M140 80 L140 200 M80 140 L200 140" stroke="rgba(0, 175, 207, 0.2)" strokeWidth="2"/>
                        </svg>
                    </div>
                </div>
            </section>

            <section className="section projects-section-main">
                <div className="container">
                    <h2 className="title page-title">Our Core Services</h2>
                    <div className="service-detail-cards-container">
                        {allServices?.map((service, index) => (
                            <ServiceDetailsCard 
                                key={index} 
                                service={service} 
                                index={index}
                            />
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}

export default Services;
